import { Link } from "react-router";
import { usePolling } from "../lib/use-polling";
import { api } from "../lib/api";
import { Ring } from "../components/topology/Ring";
import { Pulse } from "../components/primitives/Pulse";
import { PageHelp } from "../components/PageHelp";
import { InfoTip } from "../components/primitives/InfoTip";

export function Overview() {
  const overview = usePolling(() => api.getOverview(), 30000);
  const connectors = usePolling(() => api.listConnectors(), 60000);
  const pipelines = usePolling(() => api.listPipelines(), 30000);

  if (overview.status === "loading" || connectors.status === "loading" || pipelines.status === "loading") {
    return <Pulse />;
  }

  const o = overview.data;
  const pipelineList = pipelines.data?.pipelines ?? [];
  const connectorList = connectors.data?.connectors ?? [];

  const slots = connectorList.slice(0, 8).map((c: { label?: string; connectorType: string }) => {
    const count = pipelineList.filter((p: { sourceConnectorType?: string }) => p.sourceConnectorType === c.connectorType).length;
    return { label: c.label ?? c.connectorType, count };
  });

  return (
    <div>
      <div className="uppercase-label" style={{ marginBottom: 16 }}>OVERVIEW</div>
      <PageHelp />

      <div className="overview-grid">
        <div className="overview-card">
          <h3 className="overview-card__title">PIPELINES</h3>
          <div className="overview-card__row"><span className="label">active</span><span className="value">{o?.pipelines.active ?? 0}</span></div>
          <div className="overview-card__row"><span className="label">paused</span><span className="value">{o?.pipelines.paused ?? 0}</span></div>
          <div className="overview-card__row"><span className="label">total</span><span className="value">{o?.pipelines.total ?? 0}</span></div>
        </div>
        <div className="overview-card">
          <h3 className="overview-card__title">RUNS — LAST 24h</h3>
          <div className="overview-card__row"><span className="label">success</span><span className="value">{o?.runs24h.success ?? 0}</span></div>
          <div className="overview-card__row"><span className="label">fail</span><span className="value">{o?.runs24h.fail ?? 0}</span></div>
          <div className="overview-card__row"><span className="label">pending</span><span className="value">{o?.runs24h.pending ?? 0}</span></div>
        </div>
        <div className="overview-card">
          <h3 className="overview-card__title">TOP FAILURES — 24h</h3>
          {(!o?.topFailures || o.topFailures.length === 0) ? (
            <p className="page-help" style={{ margin: 0 }}>Nothing failing. The web is quiet.</p>
          ) : (
            <table className="table">
              <tbody>
                {o.topFailures.map((f) => (
                  <tr key={f.pipelineId}>
                    <td style={{ padding: "4px 0" }}>
                      <Link to={`/pipelines/${f.pipelineId}`} className="mono">{f.pipelineName ?? f.pipelineId.slice(0, 8)}</Link>
                    </td>
                    <td style={{ padding: "4px 0", textAlign: "right" }} className="mono">{f.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <div style={{ display: "flex", gap: 48, alignItems: "flex-start" }}>
        <Ring slots={slots} size={360} />
        <div>
          <div className="uppercase-label">CONNECTOR TYPES</div>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 42 }}>{connectorList.length}</div>
          <div className="uppercase-label" style={{ marginTop: 24, display: "inline-flex", alignItems: "center" }}>
            ACTIVE PIPELINES
            <InfoTip termKey="pipeline" />
          </div>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 42 }}>{o?.pipelines.active ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
